import { useQuery as useReactQuery } from '@tanstack/react-query';
import { useAuthClaims } from '../../../hooks/useAuthClaims';
import { backendApi } from '../../../utils/backendApi';
import { showUserDbErrorToast } from '../../../utils/toasts';
import { ProcuratOrganizationTable } from '../../Procurat/tables/ProcuratOrganizationTable';

type ThreemaFormProps = { onClose: () => void };

export const ProcuratSettings = ({ onClose }: ThreemaFormProps) => {
  const { pimAuthClaims } = useAuthClaims();
  const organizationUuid = pimAuthClaims.getOrganizationUuid();

  const { data, refetch } = useReactQuery({
    queryKey: ['procuratOrga'],
    queryFn: async () => {
      const response = await backendApi.fetch(`/procurat/organization`, {
        method: 'GET',
      });
      return await response.json();
    },
  });

  if (data?.error) {
    showUserDbErrorToast();
  }

  const handleSetup = async (procuratOrgaId: string) => {
    const response = await backendApi.post(
      `/procurat/setup`,
      JSON.stringify({
        procuratOrganizationUuid: procuratOrgaId,
        organizationUuid: organizationUuid,
      }),
    );

    if (!response.ok) {
      showUserDbErrorToast();
    } else {
      await refetch();
    }

    onClose();
  };

  return (
    <>
      <ProcuratOrganizationTable data={data} onSetup={handleSetup} />
    </>
  );
};
